<template>
    <div id="history-sinester">
        <main id="mainContent" class="padFixBoth">
            <div class="view">
                <div class="row">
                    <div class="col-12 col-xl-2 mb-3 mb-sm-0">
                        <b-pagination
                            pills align="fill"
                            :hide-goto-end-buttons="true" :limit="3"
                            v-model="pagination.current_page" :total-rows="pagination.total"
                            :per-page="pagination.per_page" aria-controls="my-table"
                            v-on:change="onChange"></b-pagination>
                    </div>
                    <div class="col-12 col-xl-6 mb-3 mb-sm-0">
                        <input id="filter-input" class="al-inputs scr-input" v-model="filter" type="search"
                               placeholder="Buscar por palabra">
                        <label for="filter-input" class="scr-supertext scr-extra">Buscar por palabra</label>
                    </div>
                    <div class="col-12 col-xl-2 mb-3 mb-sm-0 cont_select">
                        <select id="change_result" class="float" v-model="params.limit" v-on:change="changeLimit">
                            <option :value="10">10</option>
                            <option :value="20">20</option>
                            <option :value="30">30</option>
                            <option :value="50">50</option>
                            <option :value="100">100</option>
                        </select>
                    </div>
                </div>
            </div>
            <b-table sticky-header="80vh" responsive id="my-table" striped hover :fields="fields" :busy="isBusy"
                     :items="pagination.data" :filter="filter">
                <template #cell(sku)="{item}">
                    {{ item.sku }}
                </template>
                <template #cell(razon)="{item}">
                    <span v-if="item.relreason">{{ item.relreason.name }}</span>
                </template>
                <template #cell(lugar)="{item}">
                    <span v-if="item.relplace">{{ item.relplace.name }}</span>
                </template>
                <template #cell(atendido_por)="{item}">
                    <span v-if="item.relsupplier">{{ item.relsupplier.nom_com }}</span>
                </template>
                <template #cell(especialista)="{item}">
                <span v-if="item.relspecialty">
                    {{ item.relspecialty.especialidad }}
                </span>
                </template>
                <template #cell(fecha)="{item}">
                    {{ formatDate(item.created_at) }}
                </template>

                <template #table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                    </div>
                </template>
            </b-table>
        </main>
    </div>
</template>

<script>
import {myMixins} from "../mixins/myMixins";
import {sinisterService} from "../../Services/Sinister.service";

export default {
    name: "history-sinester-affiliate",
    mixins: [myMixins],
    props: {
        client_sku: {
            type: String,
            default: 0,
            require: false
        },
    },
    data() {
        return {
            isBusy: false,
            filter: null,
            pagination: {
                current_page: 1,
                data: [],
                first_page_url: '',
                from: 0,
                last_page: 0,
                last_page_url: '',
                links: [],
                next_page_url: '',
                path: '',
                per_page: 0,
                prev_page_url: '',
                to: 0,
                total: 0,
            },
            fields: [
                {key: 'sku'},
                {key: 'razon'},
                {key: 'lugar'},
                {key: 'atendido_por'},
                {key: 'especialista'},
                {key: 'fecha'},
            ],
            params: {
                sku: this.client_sku,
                limit: 10,
                page: 1,
                where: [
                    {
                        field: 'sku',
                        value: this.client_sku + '%',
                        operator: 'LIKE'
                    },
                ],
            },
        }
    },
    methods: {
        async index() {
            this.isBusy = true;

            this.pagination = await sinisterService.getMany(this.params);
            this.isBusy = false;
        },

        onChange(page) {
            this.params.page = page;
            this.index();
        },
        changeLimit() {
            this.index();
        },
    },
    mounted() {
        console.log(this.client_sku);
        this.index();
    }
}
</script>

